<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <div slot="header"></div>
        <!--<ul class="nav">
         <li class="nav-item">
           <a class="nav-link" href="/#/dashboard">
             <i class="nav-icon icon-speedometer"></i> COD Dashboard
           </a>
         </li>
          <li class="nav-item">
            <template>
               <SidebarNavDropdown :name="'SR Closure'" :url="'srclosure'" :icon="'srclosure'">
                 <template>
                   <li class="nav-item">
                     <SidebarNavLink :name="'SR Closure'"  :url="'srclosure'" :icon="'srclosure'"/>
                   </li>
                   <li class="nav-item">
                     <SidebarNavLink :name="'SR Closure Search'"  :url="'srclosuresearch'" :icon="'srclosuresearch'"/>
                   </li>
                 </template>
               </SidebarNavDropdown>
            </template>
          </li>
         <li class="nav-item">
            <template>
               <SidebarNavDropdown :name="'SVC Closure'" :url="'svcclosure'" :icon="'svcclosure'">
                 <template>
                   <li class="nav-item">
                     <SidebarNavLink :name="'SVC Closure P2P'"  :url="'svcclosurep2p'" :icon="'svcclosurep2p'"/>
                   </li>
                   <li class="nav-item">
                     <SidebarNavLink :name="'SVC Closure Search'"  :url="'svcclosuresearch'" :icon="'svcclosuresearch'"/>
                   </li>
                 </template>
               </SidebarNavDropdown>
            </template>
          </li>
          <li class="nav-item">
             <template>
                <SidebarNavDropdown :name="'Finance Closure'" :url="'financeclosure'" :icon="'financeclosure'">
                  <template>
                    <li class="nav-item">
                      <SidebarNavLink :name="'Bank Hub Mapping'"  :url="'mapbankhub'" :icon="'mapbankhub'"/>
                    </li>
                    <li class="nav-item">
                      <SidebarNavLink :name="'Bulk Upload To Close'"  :url="'bankfiletoclosebulkaccount'" :icon="'bankfiletoclosebulkaccount'"/>
                    </li>
                    <li class="nav-item">
                      <SidebarNavLink :name="'Finance Closure'"  :url="'financeclosure'" :icon="'financeclosure'"/>
                    </li>
                    <li class="nav-item">
                      <SidebarNavLink :name="'Finance Re-Open Closure'"  :url="'csvreopenday'" :icon="'csvreopenday'"/>
                    </li>
                    <li class="nav-item">
                      <SidebarNavLink :name="'SVC Deposit Exceptions'"  :url="'svcdepositexceptions'" :icon="'svcdepositexceptions'"/>
                    </li>
                  </template>
                </SidebarNavDropdown>
             </template>
           </li>
           <li class="nav-item">
            <template>
               <SidebarNavDropdown :name="'COD Reports'" :url="'hubwisecodreport'" :icon="'hubwisecodreport'">
                 <template>
                   <li class="nav-item">
                     <SidebarNavLink :name="'Hub Wise COD Report'"  :url="'hubwisecodreport'" :icon="'hubwisecodreport'"/>
                   </li>
                   <li class="nav-item">
                     <SidebarNavLink :name="'MIS P2P COD Report'"  :url="'misp2preport'" :icon="'misp2preport'"/>
                   </li>
                 </template>
               </SidebarNavDropdown>
            </template>
          </li>
        </ul>-->

        <ul class="nav">
          <li class="nav-item" v-for="(item, index) in navItem">

             <template v-if="item.children.length>0">
                <SidebarNavDropdown :name="item.name" :url="item.url" :icon="item.icons">
                  <template v-for="child in item.children">

                    <template v-if="child.children.length>0">
                       <SidebarNavDropdown :name="child.name" :icon="child.icons" class="nestedClass">
                         <template v-for="childInChild in child.children">
                           <template v-if="childInChild.children.length>0">
                             <SidebarNavDropdown :name="item.name" :url="item.url" :icon="item.icons" class="nestedSub-links">
                               <template v-for="nestedInChild in childInChild.children">
                                 <SidebarNavLink v-if="nestedInChild.ismenu == true" :name="nestedInChild.name"  :url="nestedInChild.url" :icon="nestedInChild.icons" v-on:click="test()"/>
                               </template>
                              </SidebarNavDropdown>
                           </template>
                           <template v-else="">
                             <SidebarNavLink v-if="childInChild.ismenu == true" :name="childInChild.name"  :url="childInChild.url" :icon="childInChild.icons" v-on:click="test()"/>
                           </template>
                         </template>
                       </SidebarNavDropdown>
                    </template>
                    <template v-else>
                      <SidebarNavLink v-if="child.ismenu == true" class="aa" :name="child.name" :icon="child.icons" :url="child.url"/>
                    </template>
                  </template>
                </SidebarNavDropdown>
             </template>
              <template v-else>
                <SidebarNavLink v-if="item.ismenu == true" :name="item.name" :icon="item.icons" :url="item.url"/>
            </template>
           </li>
        </ul>
       <slot></slot>
      <div slot="footer"></div>
    </nav>
  </div>
</template>
<script>
import SidebarNavDropdown from './SidebarNavDropdown';
import SidebarNavLink from './SidebarNavLink';
import SidebarNavTitle from './SidebarNavTitle';
 import CryptoJS from 'crypto-js';
export default {
  name: 'sidebar',
  props: {

  },
  components: {
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle
  },

  data () {
    return {
       navItem:  [],
       userDataKey:'',
     }
  },
  mounted(){
          this.userDataKey = window.localStorage.getItem('userUniqueKey');
          var permissionEncrypt = window.localStorage.getItem('lmaccesspermissiondata')
          var bytes  = CryptoJS.AES.decrypt(permissionEncrypt.toString(), this.userDataKey);
          var plaintext = bytes.toString(CryptoJS.enc.Utf8);
          //console.log('plaintext',plaintext);
          this.navItem=JSON.parse(plaintext);
          //console.log('this.navItem',this.navItem);
      },

  methods: {
    // handleClick (e) {
    //   e.preventDefault()
    //   e.target.parentElement.classList.toggle('open')
    // }
  }
}
</script>

<style lang="css">
.sidebar {
  background-color: #fff;
  color: #424242;
}
.nestedClass{
  width: 85%
}
.sidebar .nav .nav-item .nav-link.active,
.sidebar .nav .nav-item .nav-link.active i {
  font-weight: 600;
  color: #262626 !important;
  background-color: transparent;
}

.sidebar .nav .nav-item .nav-link i {
  width: 10px;
}

.sidebar .nav .nav-item.nav-dropdown.open>ul {
  /*padding-left: 30px;*/
  /*text-align: center;*/
  position: relative;
  left: 30px;
}

.sidebar .nav .nav-item.nav-dropdown.open {
  background-color: transparent;
}

.sidebar .nav .nav-item.nav-dropdown.open .nav-link .nav-dropdown-toggle {
  color: #20a8d8;
}

.sidebar .nav .nav-item.nav-dropdown.open .nav-dropdown-toggle {
  color: #20a8d 8;
}

.sidebar .nav .nav-item.nav-dropdown.open .nav-dropdown-toggle>.fa {
  color: #424242;
}

.sidebar .nav .nav-item.nav-dropdown.open .active {
  color: #424242 !important;
  background: #DEE9F1 !important;
}

.sidebar .nav .nav-item.nav-dropdown.open .active:hover {
  color: transparent;
}

.sidebar .sidebar-nav::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}

.sidebar .sidebar-nav::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

li {
  border-bottom: 1px solid gray;
}

.sidebar .nav .nav-item>li {
  border-bottom: 1px solid transparent;
}

.sidebar-minimized .sidebar .nav .nav-item ul {
  background-color: #F3F2F1;
}

.nav-link .nav-dropdown-toggle:hover {
  color: #fff;
}

.sidebar {
  border-right: 1px solid #c2cfd6;
}

.sidebar .nav .nav-item .nav-link {
  padding: 0.28rem 0.25rem;
  color : #262626;
}

.sidebar .nav .nav-item .nav-link i {
  width: 30px;
  color: #262626;
  background-color: #bbc5d6;
  padding: 7px;
  border-radius: 6px;
  font-size: 12px;
}

.sidebar .nav .nav-item .nav-link.active i {
  width: 30px;
  color: #262626;
  background-color: #F68607;
  padding: 7px;
  border-radius: 6px;
  font-size: 12px;
}

.sidebar .nav .nav-item .nav-link.active:hover i {
  color: #262626;
}

.sidebar .nav .nav-item .nav-link:hover i {
  color: #424242;
}

li {
  border-bottom: 1px dotted #b6b7b8;
}

.sidebar .nav .nav-item .nav-link.nav-dropdown-toggle::before,
.sidebar .nav .nav-item .navbar .nav-dropdown-toggle.dropdown-toggle::before,
.navbar .sidebar .nav .nav-item .nav-dropdown-toggle.dropdown-toggle::before {
  font-size: 1.7rem;
  font-weight: 600;
  top: 0.8rem;
}

.sidebar .nav .nav-item.nav-dropdown.open>ul,
.sidebar .nav .nav-item.nav-dropdown.open>ol {
  width: 100%;
  font-size: 13px;

}

.sidebar .sidebar-nav::-webkit-scrollbar-track {
  border-left: 1px solid #b6b7b8;
}

.sidebar .nav .nav-item.nav-dropdown.open .nav-link {
  border-bottom: 1px dotted #b6b7b8;
  color : #262626
}

.sidebar .nav .nav-item.nav-dropdown.open .nav-dropdown-toggle {
  background: #20a8d8;
  color: #fff;
}

.sidebar .nav .nav-item .nav-link:hover {
  background: #d2edf7;
  color: #424242;
}

.sidebar .nav .nav-item.nav-dropdown.open .active {
  color: #424242 !important;
  background: #DEE9F1 !important;
}

@media (min-width: 992px) {
  .sidebar-minimized.sidebar-fixed .sidebar {
    width: 0px;
  }

  .sidebar-minimized.sidebar-fixed .main,
  .sidebar-minimized.sidebar-fixed .app-footer {
    margin-left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue?c7a75b5c